<ng-template #contentTemplate>
  <div id="sidebar-menu" style="background-color: #fff;">
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container *ngIf="user =='role_consumer_fleet'">
    <!-- Main menu rendering excluding 'Dashboard' and 'AI Chatbot' -->
<ng-container *ngFor="let item of menuItems">
  <ng-container *ngIf="item.label !== 'Dashboard'">
    <div *ngIf="item.id === 999" class="menu-spacer"></div>
    <li class="menu-title" *ngIf="item.isTitle">{{ item.label | translate }}</li>
    <li *ngIf="!item.isTitle && !item.isLayout"  [ngClass]="{
      'fixed-bottom-chatbot': item.id === 999
    }">
      <!-- Parent item with children -->
      <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent sub-menu"
         [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
        <i style="color: #ef8321 !important;" class="bx {{ item.icon }}" *ngIf="item.icon"></i>
        <span class="fn-label"> {{ item.label | translate }}</span>
        <span class="badge rounded-pill float-end bg-{{item.badge?.variant}}"
              *ngIf="item.badge">{{ item.badge?.text | translate }}</span>
      </a>

      <!-- Regular single link item -->
      <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active">
        <i style="color: #ef8321 !important;" class="bx {{ item.icon }}" *ngIf="item.icon"></i>
        <span class="fn-label"> {{ item.label | translate }}</span>
        <span class="badge rounded-pill bg-{{item.badge?.variant}} float-end"
              *ngIf="item.badge">{{ item.badge?.text | translate }}</span>
      </a>

      <!-- Submenu level 1 -->
      <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
        <li *ngFor="let subitem of item?.subItems">
          <ng-container *ngIf="subitem?.label != 'Vehicle Summary'">
            <a [routerLink]="subitem?.link" *ngIf="!hasItems(subitem)" class="side-nav-link-ref"
               [attr.data-parent]="subitem?.parentId" routerLinkActive="active">
              {{ subitem?.label | translate }}
            </a>
          </ng-container>
          <!-- Submenu with children -->
          <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);"
             [attr.data-parent]="subitem.parentId">
            {{ subitem.label | translate }}
          </a>
          <!-- Submenu level 2 -->
          <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
            <li *ngFor="let subSubitem of subitem.subItems">
              <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                 routerLinkActive="active" class="side-nav-link-ref">
                {{ subSubitem.label | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ng-container>
</ng-container>
      </ng-container>
      <ng-container *ngIf="user == 'read_only'">
        <ng-container *ngFor="let item of menuItems">
             <ng-container
               *ngIf="item?.label != 'Dashboard'">
               <li class="menu-title" *ngIf="item.isTitle">{{ item.label | translate }}</li>
               <li *ngIf="!item.isTitle && !item.isLayout">
                 <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent sub-menu"
                   [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
                   <i style="color: #ef8321 !important;" class="bx {{item.icon}}" *ngIf="item.icon"></i>
                   <span class="fn-label"> {{ item.label | translate }}</span>
                   <span class="badge rounded-pill float-end bg-{{item.badge.variant}}"
                     *ngIf="item.badge">{{item.badge.text |
                     translate}}</span>
                 </a>
    
                 <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active">
                   <i style="color: #ef8321 !important;" class="bx {{ item.icon }}" *ngIf="item.icon"></i>
                   <span class="fn-label"> {{ item.label | translate }}</span>
                   <span class="badge rounded-pill bg-{{item.badge.variant}} float-end"
                     *ngIf="item.badge">{{item.badge.text |
                     translate}}</span>
                 </a>
    
                 <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
                   <li *ngFor="let subitem of item?.subItems">
                     <ng-container *ngIf="subitem?.label != 'Add Fleet' && subitem?.label != 'Manage Device'">
                       <a [routerLink]="subitem?.link" *ngIf="!hasItems(subitem)" class="side-nav-link-ref"
                         [attr.data-parent]="subitem?.parentId" routerLinkActive="active">
                         {{ subitem?.label | translate}}
                       </a>
                     </ng-container>
                     <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);"
                       [attr.data-parent]="subitem.parentId">
                       {{ subitem.label | translate}}
                     </a>
                     <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                       <li *ngFor="let subSubitem of subitem.subItems">
                        <ng-container *ngIf="subSubitem?.label != 'Add Fleet'">
                         <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                           routerLinkActive="active" class="side-nav-link-ref">
                           {{ subSubitem.label | translate }}
                         </a>
                         </ng-container>
                       </li>
                     </ul>
                   </li>
                 </ul>
               </li>
             </ng-container>
           </ng-container>    
         </ng-container>
      <ng-container *ngIf="user =='role_consumer'">
        <ng-container *ngFor="let item of menuItems">
          <ng-container
            *ngIf="item?.label != 'Manage TSPs' && item?.label != 'Manage Fleet' && item?.label != 'Consent Management' && item?.label != 'Manage Consent'">
            <li class="menu-title" *ngIf="item.isTitle">{{ item.label | translate }}</li>
            <li *ngIf="!item.isTitle && !item.isLayout">
              <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent"
                [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
                <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
                <span> {{ item.label | translate }}</span>
                <span class="badge rounded-pill float-end bg-{{item.badge.variant}}"
                  *ngIf="item.badge">{{item.badge.text |
                  translate}}</span>
              </a>

              <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active">
                <i class="bx {{ item.icon }} icon-color" style="color:#6a7187 !important" *ngIf="item.icon"></i>
                <span style="color:#6a7187 !important;font-size: 15px;
                font-weight: 500;"> {{ item.label | translate }}</span>
                <span class="badge rounded-pill bg-{{item.badge.variant}} float-end"
                  *ngIf="item.badge">{{item.badge.text |
                  translate}}</span>
              </a>

              <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
                <li *ngFor="let subitem of item.subItems">
                  <ng-container *ngIf="subitem.label != 'Vehicle Summary'">
                    <a [routerLink]="subitem.link" *ngIf="!hasItems(subitem)" class="side-nav-link-ref"
                      [attr.data-parent]="subitem.parentId" routerLinkActive="active">
                      {{ subitem.label | translate}}
                    </a>
                  </ng-container>
                  <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);"
                    [attr.data-parent]="subitem.parentId">
                    {{ subitem.label | translate}}
                  </a>
                  <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                    <li *ngFor="let subSubitem of subitem.subItems">
                      <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                        routerLinkActive="active" class="side-nav-link-ref">
                        {{ subSubitem.label | translate }}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="user =='role_admin'">
          <ng-container *ngFor="let item of menuItems">
          <ng-container
          *ngIf="item?.label == 'Dashboard' || item?.label == 'Report' || item?.label == 'Reports'">
            <li class="menu-title" *ngIf="item.isTitle">{{ item.label | translate }}</li>
            <li *ngIf="!item.isTitle && !item.isLayout">
              <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent sub-menu"
                [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
                <i style="color: #ef8321 !important;" class="bx {{item.icon}}" *ngIf="item.icon"></i>
                <span class="fn-label"> {{ item.label | translate }}</span>
                <span class="badge rounded-pill float-end bg-{{item.badge.variant}}"
                  *ngIf="item.badge">{{item.badge.text |
                  translate}}</span>
              </a>
 
              <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active">
                <i style="color: #ef8321 !important;" class="bx {{ item.icon }}" *ngIf="item.icon"></i>
                <span class="fn-label"> {{ item.label | translate }}</span>
                <span class="badge rounded-pill bg-{{item.badge.variant}} float-end"
                  *ngIf="item.badge">{{item.badge.text |
                  translate}}</span>
              </a>
 
              <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
                <li *ngFor="let subitem of item?.subItems">
                  <ng-container *ngIf="subitem?.label != 'Vehicle Summary'">
                    <a [routerLink]="subitem?.link" *ngIf="!hasItems(subitem)" class="side-nav-link-ref"
                      [attr.data-parent]="subitem?.parentId" routerLinkActive="active">
                      {{ subitem?.label | translate}}
                    </a>
                  </ng-container>
                  <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);"
                    [attr.data-parent]="subitem.parentId">
                    {{ subitem.label | translate}}
                  </a>
                  <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                    <li *ngFor="let subSubitem of subitem.subItems">
                      <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                        routerLinkActive="active" class="side-nav-link-ref">
                        {{ subSubitem.label | translate }}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ng-container>
          </ng-container>
      </ng-container>
     
    </ul>
  </div>
</ng-template>
<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>